import * as Yup from "yup";

// Valores iniciales para el formulario de registro
export function initialValues() {
  return {
    avatar: "", // Pregunta si hay un usuario y si lo hay toma el avatar, si no, usa un string vacío
    fileAvatar: null,
    firstname: "",
    lastname: "",
    country: "España",
    address: "",
    phone: "",
    role: "free", // Valor por defecto 'user' para Cuenta Free
    email: "",
    password: "",
    repeatPassword: "",
    holded: "", // Campo opcional para Partner
    conditionsAccepted: false,
    // Opt-in de marketing (drip de nurture). Desmarcado por defecto (RGPD).
    marketingConsent: false,
    code: "",
  };
}

// Esquema de validación con Yup
export function validationSchema(verificationSent, t) {
  return Yup.object({
    firstname: Yup.string().required(t("auth:validation.nameRequired")),
    lastname: Yup.string().required(t("auth:validation.lastNameRequired")),
    country: Yup.string().required(t("auth:validation.countryRequired")),
    address: Yup.string(),
    phone: Yup.string().matches(/^\+?\d+$/, t("auth:validation.phoneFormat")),
    role: Yup.string()
      .oneOf(["free"], t("auth:validation.roleInvalid"))
      .required(t("auth:validation.roleRequired")),
    // Campo opcional para partner:
    holded: Yup.string(),
    email: Yup.string()
      .email(t("auth:validation.emailInvalid"))
      .required(t("auth:validation.required")),
    password: Yup.string()
      .min(8, t("auth:validation.passwordMin"))
      .required(t("auth:validation.passwordRequiredField")),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref("password")], t("auth:validation.passwordsMatch"))
      .min(8, t("auth:validation.passwordMin"))
      .required(t("auth:validation.passwordRequiredField")),
    conditionsAccepted: Yup.bool()
      .oneOf([true], t("auth:validation.termsRequired"))
      .required(t("auth:validation.passwordRequiredField")),
    code: Yup.string().when("verificationSent", {
      is: true,
      then: Yup.string()
        .required(t("auth:validation.codeRequired"))
        .matches(/^[0-9]{6}$/, t("auth:validation.codeFormat")),
    }),
  });
}
